import { type ContentComponent, type SpecialPricingFormPlaceholderContent } from '../../../../types/construct.types';
import { ContactUsForm } from '../../../support-components/contact-us-form/contact-us-form.component';

export const SpecialPricingFormPlaceholder: ContentComponent<SpecialPricingFormPlaceholderContent> = () => (
	<ContactUsForm isSpecialPricing={true} />
);
